import { SubpageShell } from "@/components/layout/SubpageShell";
import { Album } from "@/components/landing/Album";

export default function AlbumPage() {
  return (
    <div data-testid="album-page">
      <SubpageShell titleZh="团队相册" titleEn="Photo Album">
        <Album />
      </SubpageShell>
    </div>
  );
}
